// HACK: When we cannot actually re-fetch a list from where we are, we just reload the location...
// Many contexts are so detached from the data source that it's too much of a hassle to actually update it when it changes.
export const performCavemanReFetch = () => location.reload()
